import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "options-container" }
const _hoisted_3 = { class: "download-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString($setup.t('VIDEO UPLOAD SUCCESS')), 1),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check-circle'] }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString($setup.t('DOWNLOAD VIDEO LABEL')), 1),
          _createVNode(_component_Button, {
            variant: "link",
            onclick: () => $setup.handleDownload()
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('DOWNLOAD VIDEO')), 1)
            ]),
            _: 1
          }, 8, ["onclick"])
        ])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check-circle'] }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString($setup.t('VIDEO STUDIO INFO')), 1),
          _createVNode(_component_Button, { href: "https://www.icims.com/talent-cloud-recruiting/platform/video-studio/" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('HERE')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}